"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAuctionDtoAuctionStatusEnum = exports.UserAuctionDtoListingStatusEnum = exports.UserAuctionDtoListingTypeEnum = void 0;
exports.instanceOfUserAuctionDto = instanceOfUserAuctionDto;
exports.UserAuctionDtoFromJSON = UserAuctionDtoFromJSON;
exports.UserAuctionDtoFromJSONTyped = UserAuctionDtoFromJSONTyped;
exports.UserAuctionDtoToJSON = UserAuctionDtoToJSON;
exports.UserAuctionDtoToJSONTyped = UserAuctionDtoToJSONTyped;
var UserAuctionPropertyDto_1 = require("./UserAuctionPropertyDto");
var UserAuctionBidDto_1 = require("./UserAuctionBidDto");
/**
 * @export
 */
exports.UserAuctionDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.UserAuctionDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * @export
 */
exports.UserAuctionDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * Check if a given object implements the UserAuctionDto interface.
 */
function instanceOfUserAuctionDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('auctionStatus' in value) || value['auctionStatus'] === undefined)
        return false;
    if (!('salePrice' in value) || value['salePrice'] === undefined)
        return false;
    if (!('property' in value) || value['property'] === undefined)
        return false;
    if (!('userBid' in value) || value['userBid'] === undefined)
        return false;
    return true;
}
function UserAuctionDtoFromJSON(json) {
    return UserAuctionDtoFromJSONTyped(json, false);
}
function UserAuctionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'listingType': json['listingType'],
        'listingStatus': json['listingStatus'],
        'auctionStatus': json['auctionStatus'],
        'salePrice': json['salePrice'],
        'startPrice': json['startPrice'] == null ? undefined : json['startPrice'],
        'highestBidPrice': json['highestBidPrice'] == null ? undefined : json['highestBidPrice'],
        'winningBidId': json['winningBidId'] == null ? undefined : json['winningBidId'],
        'winningBidAmount': json['winningBidAmount'] == null ? undefined : json['winningBidAmount'],
        'property': (0, UserAuctionPropertyDto_1.UserAuctionPropertyDtoFromJSON)(json['property']),
        'userBid': (0, UserAuctionBidDto_1.UserAuctionBidDtoFromJSON)(json['userBid']),
    };
}
function UserAuctionDtoToJSON(json) {
    return UserAuctionDtoToJSONTyped(json, false);
}
function UserAuctionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'listingType': value['listingType'],
        'listingStatus': value['listingStatus'],
        'auctionStatus': value['auctionStatus'],
        'salePrice': value['salePrice'],
        'startPrice': value['startPrice'],
        'highestBidPrice': value['highestBidPrice'],
        'winningBidId': value['winningBidId'],
        'winningBidAmount': value['winningBidAmount'],
        'property': (0, UserAuctionPropertyDto_1.UserAuctionPropertyDtoToJSON)(value['property']),
        'userBid': (0, UserAuctionBidDto_1.UserAuctionBidDtoToJSON)(value['userBid']),
    };
}
